// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-body {
  background-image: url("https://cdn.elluciancloud.com/assets/EDS2/7.18.1/img/bg/DegreeWorks-CRM-Background.png");
  background-size: cover;
}

.loginContent {
  margin-bottom: 2.6rem;
  /*The min-height here accounts for the approximately 64 pixel height of the footer */
  min-height: calc(100vh - 113px);
}

.signInAgain:focus {
  outline: none !important;
  border: 0.125rem solid #51abff !important;
  border-radius: 0.4rem !important;
}

.logoutContent {
  margin-top: 2.6rem;
  /*The min-height here accounts for the approximately 64 pixel height of the footer */
  min-height: calc(100vh - 177px);
}

.loadingIndicator {
  position: fixed;
  left: 50%;
  top: 50%;
}

.no-padding {
  padding: 0;
}

.grid-button-row {
  margin: 1rem !important;
  margin-bottom: 0rem !important;
  margin-right: 0rem !important;
  width: 102px;
}

/* Scrollbar (Web-kit) */
.table-scrollbar::-webkit-scrollbar-track {
  border-radius: 10px;
}

.table-scrollbar::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #fff;
}

.table-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #cbcbcb;
}

footer {
  position: static;
  width: 100%;
  bottom: 0;
  border-top: 0.0625rem solid #ccc;
}

main {
  padding: 1rem;
  padding-top: 0rem;
  max-width: 90%;
  margin: auto;
  display: flex;
  flex-direction: column;
  margin-top: 5rem;
  /*The min-height here accounts for the approximately 64 pixel height of the footer */
  min-height: calc(100vh - 9.3rem);
}

@media (max-width: 600px) {
  main {
    padding: 0.75rem;
    max-width: 100%;
    margin-top: 4rem;
    /*The min-height here accounts for the approximately 64 pixel height of the footer */
    min-height: calc(100vh - 8.9rem);
  }

  .card-container {
    padding: 1rem !important;
  }

  .loginContent {
    margin-bottom: 3.3rem;
    /*The min-height here accounts for the approximately 82 pixel height of the footer on mobile device */
    min-height: calc(100vh - 129px);
  }

  .logoutContent {
    margin-top: 3.3rem;
    /*The min-height here accounts for the approximately 82 pixel height of the footer on mobile device */
    min-height: calc(100vh - 193px);
  }

  .LoginForm-card-95 {
    margin-top: 0rem !important;
  }

  .controller-content {
    padding: 1rem;
    padding-top: 0rem;
    max-width: 82rem;
    margin: auto;
    display: flex;
    flex-direction: column;
    margin-top: 4rem;
    /*The min-height here accounts for the approximately 64 pixel height of the footer */
    min-height: calc(100vh - 10.25rem);
  }

  .grid-checkbox {
    margin-left: 0.5rem !important;
    margin-right: 0.5rem !important;
  }

  .grid-button-row {
    margin: 1rem !important;
    margin-top: 0.5rem !important;
    margin-bottom: 0rem !important;
    width: 98%;
  }

  .grid-button-row-cancel {
    margin: 1rem !important;
    margin-top: 0.5rem !important;
    margin-bottom: 2rem !important;
    width: 98%;
  }
}

@media print {
  body {
    padding-top: 72px;
    padding-bottom: 72px;
    background-color: #fff;
  }

  .root {
    background-color: #fff !important;
  }

  .ace-editor .ace-content {
    visibility: hidden !important;
    height: 0rem !important;
    max-height: 0rem !important;
  }

  [class^="ace-"] {
    visibility: hidden !important;
    height: 0rem !important;
    max-height: 0rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./style/style.css"],"names":[],"mappings":"AAAA;EACE,+GAA+G;EAC/G,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,oFAAoF;EACpF,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,oFAAoF;EACpF,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,6BAA6B;EAC7B,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,oFAAoF;EACpF,gCAAgC;AAClC;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,oFAAoF;IACpF,gCAAgC;EAClC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB;IACrB,qGAAqG;IACrG,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,qGAAqG;IACrG,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,oFAAoF;IACpF,kCAAkC;EACpC;;EAEA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,UAAU;EACZ;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,UAAU;EACZ;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,2BAA2B;EAC7B;AACF","sourcesContent":[".page-body {\n  background-image: url(\"https://cdn.elluciancloud.com/assets/EDS2/7.18.1/img/bg/DegreeWorks-CRM-Background.png\");\n  background-size: cover;\n}\n\n.loginContent {\n  margin-bottom: 2.6rem;\n  /*The min-height here accounts for the approximately 64 pixel height of the footer */\n  min-height: calc(100vh - 113px);\n}\n\n.signInAgain:focus {\n  outline: none !important;\n  border: 0.125rem solid #51abff !important;\n  border-radius: 0.4rem !important;\n}\n\n.logoutContent {\n  margin-top: 2.6rem;\n  /*The min-height here accounts for the approximately 64 pixel height of the footer */\n  min-height: calc(100vh - 177px);\n}\n\n.loadingIndicator {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n}\n\n.no-padding {\n  padding: 0;\n}\n\n.grid-button-row {\n  margin: 1rem !important;\n  margin-bottom: 0rem !important;\n  margin-right: 0rem !important;\n  width: 102px;\n}\n\n/* Scrollbar (Web-kit) */\n.table-scrollbar::-webkit-scrollbar-track {\n  border-radius: 10px;\n}\n\n.table-scrollbar::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n  background-color: #fff;\n}\n\n.table-scrollbar::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #cbcbcb;\n}\n\nfooter {\n  position: static;\n  width: 100%;\n  bottom: 0;\n  border-top: 0.0625rem solid #ccc;\n}\n\nmain {\n  padding: 1rem;\n  padding-top: 0rem;\n  max-width: 90%;\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  margin-top: 5rem;\n  /*The min-height here accounts for the approximately 64 pixel height of the footer */\n  min-height: calc(100vh - 9.3rem);\n}\n\n@media (max-width: 600px) {\n  main {\n    padding: 0.75rem;\n    max-width: 100%;\n    margin-top: 4rem;\n    /*The min-height here accounts for the approximately 64 pixel height of the footer */\n    min-height: calc(100vh - 8.9rem);\n  }\n\n  .card-container {\n    padding: 1rem !important;\n  }\n\n  .loginContent {\n    margin-bottom: 3.3rem;\n    /*The min-height here accounts for the approximately 82 pixel height of the footer on mobile device */\n    min-height: calc(100vh - 129px);\n  }\n\n  .logoutContent {\n    margin-top: 3.3rem;\n    /*The min-height here accounts for the approximately 82 pixel height of the footer on mobile device */\n    min-height: calc(100vh - 193px);\n  }\n\n  .LoginForm-card-95 {\n    margin-top: 0rem !important;\n  }\n\n  .controller-content {\n    padding: 1rem;\n    padding-top: 0rem;\n    max-width: 82rem;\n    margin: auto;\n    display: flex;\n    flex-direction: column;\n    margin-top: 4rem;\n    /*The min-height here accounts for the approximately 64 pixel height of the footer */\n    min-height: calc(100vh - 10.25rem);\n  }\n\n  .grid-checkbox {\n    margin-left: 0.5rem !important;\n    margin-right: 0.5rem !important;\n  }\n\n  .grid-button-row {\n    margin: 1rem !important;\n    margin-top: 0.5rem !important;\n    margin-bottom: 0rem !important;\n    width: 98%;\n  }\n\n  .grid-button-row-cancel {\n    margin: 1rem !important;\n    margin-top: 0.5rem !important;\n    margin-bottom: 2rem !important;\n    width: 98%;\n  }\n}\n\n@media print {\n  body {\n    padding-top: 72px;\n    padding-bottom: 72px;\n    background-color: #fff;\n  }\n\n  .root {\n    background-color: #fff !important;\n  }\n\n  .ace-editor .ace-content {\n    visibility: hidden !important;\n    height: 0rem !important;\n    max-height: 0rem !important;\n  }\n\n  [class^=\"ace-\"] {\n    visibility: hidden !important;\n    height: 0rem !important;\n    max-height: 0rem !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
